'use strict';

module.exports = require('./lib/csjs');



/*****************
 ** WEBPACK FOOTER
 ** ./~/csjs/csjs.js
 ** module id = 13
 ** module chunks = 0
 **/